import { SACBackendService } from "./SACBackendService";
import { SACFrontendService } from "./SACFrontendService";
/**
 * Factory for creating SAC services
 */
export class SACServiceFactory {
    /**
     * Create an SAC service for backend
     * @returns An SAC service object for backend
     */
    static createForBackend(fetchImpl) {
        return new SACBackendService(fetchImpl);
    }
    /**
     * Create an SAC service for frontend
     * @param handleSACAPICall - The function callable to call to SAC to avoid CORS
     * @returns An SAC service object for frontend
     */
    static createForFrontend(url, handleSACAPICall) {
        return new SACFrontendService(url, handleSACAPICall);
    }
}
